import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: {
        "Content-Type": "application/json; charset=utf-8",
    },
});

export const adminApi = axios.create({
    baseURL: `${BASE_URL}/api/admin`,
    headers: {
        "Content-Type": "application/json; charset=utf-8",
    },
});

export const setAdminToken = (token) => {
    if (token) {
        adminApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete adminApi.defaults.headers.common["Authorization"];
    }
};

// Public endpoints
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchCatalog = () => api.get("/catalog").then((r) => r.data);
export const fetchContent = (key) => api.get(`/content/${key}`).then((r) => r.data);
export const fetchSiteSettings = () => api.get("/site-settings").then((r) => r.data);

// Admin auth
export const adminLogin = (credentials) =>
    adminApi.post("/login", credentials).then((r) => r.data);
export const adminMe = () => adminApi.get("/me").then((r) => r.data);
export const adminLogout = () => adminApi.post("/logout").then((r) => r.data);

// Admin categories
export const listAdminCategories = () => adminApi.get("/categories").then((r) => r.data);
export const createAdminCategory = (data) =>
    adminApi.post("/categories", data).then((r) => r.data);
export const updateAdminCategory = (id, data) =>
    adminApi.put(`/categories/${id}`, data).then((r) => r.data);
export const deleteAdminCategory = (id) =>
    adminApi.delete(`/categories/${id}`).then((r) => r.data);

// Admin products
export const listAdminProducts = () =>
    adminApi.get("/products").then((r) => r.data);
export const createAdminProduct = (data) =>
    adminApi.post("/products", data).then((r) => r.data);
export const updateAdminProduct = (id, data) =>
    adminApi.put(`/products/${id}`, data).then((r) => r.data);
export const uploadAdminPhoto = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const auth = adminApi.defaults.headers.common["Authorization"];
    const res = await fetch(`${BASE_URL}/api/admin/upload`, {
        method: "POST",
        headers: auth ? { Authorization: auth } : {},
        body: formData,
    });
    const data = await res.json();
    if (!res.ok) {
        const err = new Error(data.detail || "Upload failed");
        err.response = { data };
        throw err;
    }
    return data;
};
export const deleteAdminProduct = (id) =>
    adminApi.delete(`/products/${id}`).then((r) => r.data);

// Admin content
export const listAdminContent = () => adminApi.get("/content").then((r) => r.data);
export const getAdminContent = (key) => adminApi.get(`/content/${key}`).then((r) => r.data);
export const updateAdminContent = (key, data) =>
    adminApi.put(`/content/${key}`, { data }).then((r) => r.data);

// Admin settings
export const listAdminSettings = () => adminApi.get("/site-settings").then((r) => r.data);
export const updateAdminSetting = (key, value) =>
    adminApi.put(`/site-settings/${key}`, { value }).then((r) => r.data);

// Admin submissions
export const listAdminQuotes = () => adminApi.get("/quote-requests").then((r) => r.data);
export const listAdminContacts = () => adminApi.get("/contacts").then((r) => r.data);
